import React, { useState } from 'react';
import {
  Box, BoxContent, BoxInner, BoxTitle,
} from '../../../../../view/Boxes';

interface Props {
  img: string;
  content: string;
  title: string;
  onClick?: () => void;
}

export function ProductBox({
  img, content, title, onClick,
}: Props): JSX.Element {
  const [hovered, setHovered] = useState(false);
  return (
    <Box
      onMouseEnter={(): void => setHovered(true)}
      onMouseLeave={(): void => setHovered(false)}
      img={img}
      onClick={onClick}
    >
      <BoxInner>
        <BoxTitle>
          {title}
        </BoxTitle>
        <BoxContent hovered={hovered}>
          {content}
        </BoxContent>
      </BoxInner>
    </Box>
  );
}
